import type { GQL_ID } from '@@partner:types:graphql'

import React from 'react'
import { useCartFetchCartProductDetails } from '@@partner:graphql/query/cart/cartProductDetails'
import { formatPrice } from '@@partner:helpers/util'
import { getAmountStep } from '@@partner:helpers/product'

import { Button, Tag } from 'rsuite'
import LegacyTrashIcon from '@rsuite/icons/legacy/Trash'
import AppLoader from '@components/common/AppLoader'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import ProductCardControls from '../product/ProductCardControls'

import './CartProductCard.scss'

export interface CartProductCardProps {
  id: GQL_ID
  total: number
  amount: number
  shop_id: GQL_ID
  readOnly?: boolean
  onChangeAmount?: (id: GQL_ID, amount: number) => void
  onDeleteProduct?: (id: GQL_ID) => void
}

export default function CartProductCard ({
  id,
  amount,
  total,
  readOnly = false,
  shop_id,
  onDeleteProduct,
  onChangeAmount
}: CartProductCardProps) {
  const { data, loading, error } = useCartFetchCartProductDetails(id, shop_id)

  const productDetails = data?.productDetails

  const handleAmountChange = (amount: number) => {
    onChangeAmount?.(id, amount)
  }

  if (error) {
    return (
      <GraphQLCommonErrorDisplay error={error}>
        {!readOnly && (
          <Button color="red" size="xs" onClick={() => onDeleteProduct?.(id)}>
            Убрать товар из корзины
          </Button>
        )}
      </GraphQLCommonErrorDisplay>
    )
  }

  return (
    <div className="CartProductCard">
      <div className="CartProductCard__Info">
        {loading ? (
          <AppLoader.Inline text="Loading product" />
        ) : (
          <div>
            <strong>{productDetails?.name}</strong>
            <div className="CartProductCard__Info__Values">
              <span className="CartProductCard__Info__Price">
                Цена:{' '}
                <Tag color="green">{formatPrice(productDetails?.price)}</Tag>
              </span>
              <span className="CartProductCard__Info__Total">
                Стоимость: <Tag color="violet">{formatPrice(total)}</Tag>
              </span>
              <span className="CartProductCard__Info__Total">
                Статус:{' '}
                {Math.random() * 100 > 30 ? (
                  <Tag color="green">Собран</Tag>
                ) : Math.random() * 100 > 60 ? (
                  <Tag color="orange">Связаться</Tag>
                ) : (
                  <Tag color="blue">Собирается</Tag>
                )}
              </span>
            </div>
            {readOnly && (
              <span className="CartProductCard__Info__Amount">
                Количество: <Tag>{amount}</Tag>
              </span>
            )}
          </div>
        )}
      </div>
      {!readOnly && (
        <>
          <div className="CartProductCard__Controls">
            <ProductCardControls
              amount={amount}
              amountStep={productDetails ? getAmountStep(productDetails) : 1}
              onAmountChange={handleAmountChange}
            />
          </div>
          <div className="CartProductCard__Delete">
            <Button size="xs" color="red" onClick={() => onDeleteProduct?.(id)}>
              <LegacyTrashIcon />
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
